import {Component, Input, OnInit, EventEmitter, Output} from 'angular2/core';
import {TranslatePipe} from "ng2-translate";
import {Campaign} from "../../../models/campaign.model";
import {CampaignService} from "../campaign.service";

@Component({
    selector: 'codes-modal',
    templateUrl: './app/components/campaigns/form/codes_modal.html',
    pipes: [TranslatePipe],
    providers: [CampaignService]
})
export class CampaignCodesModalComponent implements OnInit {
    @Input()
    campaign:Campaign;

    @Output()
    redirect = new EventEmitter();

    downloading:boolean;

    constructor(private _campaignService:CampaignService) {
        this.downloading = false;
    }

    ngOnInit() {
        jQuery("#codesModal").on('hidden.bs.modal', closeEvent => this.redirect.emit("event"));
    }

    download() {
        this.downloading = true;
        this._campaignService.getDownloadCsv(this.campaign.id).subscribe(() => {
            this.downloading = false;
        });
    }

}
